import { GeneralModel } from "./general.model";

export class ListReceiptMoneyStatus extends  GeneralModel {
   
}